"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultColors = exports.pi = exports.defaultConfig = void 0;
exports.defaultConfig = {
    angle: 80,
    height: 20,
    ir: 0.6,
    fixed: 2,
    moveDistance: 0.05,
    onClick: function (index) { return null; },
    showTooltips: true,
    showLabelPercentage: true,
    size: 0.8,
    showLabels: true,
    stroke: 'white',
    strokeWidth: 1,
    textSize: 12,
    tooltipShowName: true,
    tooltipShowPercentage: true,
    tooltipShowValue: true
};
exports.pi = Math.PI;
exports.defaultColors = [
    'limegreen',
    'mediumvioletred',
    'mediumpurple',
    'orange',
    'firebrick',
    'chartreuse',
    'dodgerblue',
    'tomato'
];
